module.exports = __webpack_public_path__ + "static/mindlance-logo-91d7eb8d0f9ceafb37c5f3cb0af8553f.png";